import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import {
    getCreateRulePayload,
    getUpdateRulePayload,
} from '../../services/api/apiPayloads';
// import {
//     createRule,
//     deleteRule,
//     getRule,
//     updateRule,
// } from '../../services/api/ruleApi';
import * as C from '../../services/constants';
import { extractPoints, parseRule } from '../../services/ruleUtils';
import { normalizeString } from '../../services/typeUtils';
import { hideLoading, showLoading } from '../../store/actions/loadingActions';
import {
    notify,
    notifyError,
    notifySuccess,
} from '../../store/actions/notificationActions';
import ConditionCreator from './ConditionCreator';
import ConfirmDialog from './ConfirmDialog';
import { eventFields } from './RuleFields';

import closeIcon from '../../resources/images/close-rule-editor.svg';
import DynamicRuleEditor from './DynamicRuleEditor/DynamicRuleEditor';
import {
    ATTRIBUTE_TYPE_BASED_ON_OPERATION,
    generateMvelExpression,
    parseActionExpression,
    parseMvelExpression,
} from './DynamicRuleEditor/utils/utils';
import { getActionList, getEntityAttribute } from '../../services/api/nbaApi';
import ActionCreator from './DynamicRuleEditor/ActionCreator';
import {
    createRule,
    deleteRule,
    getRule,
    updateRule,
} from '../../services/api/nbaApi';
import Frequency from './DynamicRuleEditor/Frequency';
import { format } from 'date-fns';
import FileConfigForm from './DynamicRuleEditor/FileConfigForm';
import { setGroupDetails } from '../../store/actions/navActions';

const RuleEditor = ({ onClose, ruleId, status, type, origin }) => {
    const domains = Object.keys(eventFields);

    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state);
    const { market, category, brand } = auth.user;
    const [domain, setDomain] = useState(domains[0]);
    const [isScheduleAdded, setIsScheduleAdded] = useState(false);
    //console.log("isScheduleAdded", isScheduleAdded);
    const [event, setEvent] = useState({
        domain: domain,
        attributeName: 'register',
        operation: '==',
        attributeValue: 'NOT_REQUIRED',
    });

    const [rulesData, setRulesData] = useState([]);
    const [rule, setRule] = useState();
    const [actionsData, setActionsData] = useState([
        { actionId: '', priority: '' },
    ]);
    const [scheduleData, setScheduleData] = useState({
        frequency: '',
        dayName: '',
        hourlyVal: '',
        loadType: '',
        scheduleTime: '',
        firstExecutionTime: '',
        fileType: '',
        fileFields: '',
        channelOfCommunication: ''
    });
    //const [scheduleData, setScheduleData] = useState({});
    useEffect(() => {
        if (
            scheduleData?.frequency !== '' &&
            scheduleData?.loadType !== '' &&
            scheduleData?.scheduleTime !== '' &&
            scheduleData?.firstExecutionTime !== '' &&
            ((scheduleData?.frequency !== 'WEEKLY' &&
                scheduleData?.frequency !== 'DAILY' &&
                scheduleData?.hourlyVal !== '') ||
                (scheduleData?.frequency !== 'DAILY' &&
                    scheduleData?.frequency !== 'HOURLY' &&
                    scheduleData?.dayName !== '') ||
                scheduleData?.frequency === 'DAILY')
        ) {
            setIsScheduleAdded(true);
        } else {
            setIsScheduleAdded(false);
        }
    }, [scheduleData]);

    //console.log("rulesData JSON", rulesData);
    //console.log("scheduleData JSON", JSON.stringify(scheduleData));
    const [loading, setLoading] = useState(false);
    const [conditions, setConditions] = useState([]);
    const [action, setAction] = useState({
        domain: 'CONSUMER',
        attributeName: 'points',
        operation: '==',
        attributeValue: '',
    });
    const [description, setDescription] = useState('');
    const [customRuleName, setCustomRuleName] = useState('');
    const [saveEnabled, setSaveEnabled] = useState(true);
    const [confirmDialog, setConfirmDialog] = useState({
        display: false,
        title: '',
        message: '',
        note: '',
        onClose: null,
        onConfirm: null,
        confirmText: '',
        backText: '',
    });

    useEffect(()=>{
        dispatch(setGroupDetails(rulesData));
    },[rulesData]);

    const [validationErrors, setValidationErrors] = useState({
        description: false,
        rules: false,
        schedule: false,
    });
    // Add this near other useState declarations
    const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
    const [isDraftMode, setIsDraftMode] = useState(false);

    const handleDomainChange = (e) => {
        const selectedDomain = e.target.value;
        const defaultEventAttributes = eventFields[selectedDomain].reduce(
            (acc, field) => {
                if (field.type === 'dropdown') {
                    acc[field.name] = field.values[0] || '';
                } else {
                    acc[field.name] = '';
                }
                return acc;
            },
            {}
        );
        setDomain(selectedDomain);
        setEvent({
            domain: selectedDomain,
            ...defaultEventAttributes,
        });
        setConditions([]);
    };

    const handleEventChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'attributeValue': {
                if (C.REGEX_RULE_EVENT_ATTRIBUTE.test(value) || value === '') {
                    setEvent((prevEvent) => {
                        const updatedEvent = {
                            ...prevEvent,
                            attributeValue: value,
                        };
                        return updatedEvent;
                    });
                }
                break;
            }
            default: {
                setEvent((prevEvent) => {
                    const updatedEvent = { ...prevEvent, [name]: value };
                    return updatedEvent;
                });
                break;
            }
        }
    };
    const handleAddCondition = () => {
        setConditions((prevConditions) => [
            ...prevConditions,
            {
                join: '&&',
                domain: 'CONSUMER',
                attributeName: 'points',
                operation: '>=',
                attributeValue: '',
            },
        ]);
    };

    const handleDeleteCondition = (index) => {
        // if (index === 0 && conditions.length === 1) {
        //     return;
        // }
        setConditions((prevConditions) =>
            prevConditions.filter((_, i) => i !== index)
        );
    };

    const handleConditionChange = (newCondition, index) => {
        setConditions((prevConditions) => {
            const updatedConditions = [...prevConditions];
            updatedConditions[index] = newCondition;
            return updatedConditions;
        });
    };

    const handleActionChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'attributeValue': {
                if (C.REGEX_RULE_USER_POINTS.test(value) || value === '') {
                    setAction((prevAction) => ({
                        ...prevAction,
                        attributeValue: value,
                    }));
                }
                break;
            }
            default: {
                setAction((prevAction) => {
                    const updatedAction = { ...prevAction, [name]: value };
                    return updatedAction;
                });
                break;
            }
        }
    };
    const handleDescriptionChange = (e) => {
        const { value, selectionStart } = e.target;
        const prefix = generateRuleNamePrefix();
        const upperCaseValue = value?.toUpperCase()?.replace(" ", "-");

        if (selectionStart < prefix.length) {
            e.target.setSelectionRange(prefix.length, prefix.length);
            return;
        }

        if (!upperCaseValue.startsWith(prefix)) {
            const customPart = upperCaseValue;
            if (customPart.length <= 50) {
                if (
                    C.REGEX_RULE_DESCRIPTION.test(
                        normalizeString(customPart)
                    ) ||
                    customPart === ''
                ) {
                    setDescription(prefix + customPart);
                }
            }
            return;
        }

        const customPart = upperCaseValue.startsWith(prefix)
            ? upperCaseValue.substring(prefix.length)
            : upperCaseValue;

        if (upperCaseValue.length <= 65) {
            // Reduced limit since prefix takes space
            if (
                C.REGEX_RULE_DESCRIPTION.test(normalizeString(customPart)) ||
                customPart === ''
            ) {
                setCustomRuleName(customPart);
                setDescription(prefix + customPart);
            }
        }

        if (validationErrors.description) {
            setValidationErrors((prev) => ({ ...prev, description: false }));
        }
    };
    const validateRulesData = () => {
        const stateVariables = [event, ...conditions, action, description];
        const hasNullOrUndefined = (variable) =>
            variable === null || variable === undefined;

        const hasEmptyValue = stateVariables.some((variable) => {
            if (hasNullOrUndefined(variable)) {
                return true;
            }

            if (typeof variable === 'object') {
                return Object.values(variable).some(
                    (value) => hasNullOrUndefined(value) || value.trim() === ''
                );
            } else if (typeof variable === 'string') {
                return variable.trim() === '';
            }

            return false;
        });

        return !hasEmptyValue;
    };
    const generateRule = () => {
        let ruleAction = `output.setPoints(${action.attributeValue.trim()});output.setoNamespace('LOYALTY_TRANSACTION')`;
        let triggerString = `(input.domain == '${event.domain.trim()}' && input.${
            event.attributeName
        } == ${
            event.domain !== 'CONSUMER'
                ? `'${event.attributeValue.trim()}'`
                : 'true'
        })`;
        let conditionString = conditions
            .map((condition) => {
                return `${condition.join} (${
                    condition.domain !== 'CONSUMER'
                        ? `input.domain == '${condition.domain.trim()}' && `
                        : ''
                }input.${condition.attributeName.trim()} ${condition.operation.trim()} '${condition.attributeValue.trim()}')`;
            })
            .join(' ');

        let ruleCondition = `${triggerString} ${
            event.attributeName !== 'register' ? conditionString : ''
        }`.trim();

        return [ruleCondition, ruleAction];
    };

    const saveRule = () => {
        //const [ruleCondition, ruleAction] = generateMvelExpression(rulesData, actionsData, ATTRIBUTE_TYPE_BASED_ON_OPERATION);
        const updatedScheduleData = {
            ...scheduleData,
            scheduleTime: format(scheduleData?.scheduleTime, 'HH:mm'),
            firstExecutionTime: format(
                scheduleData?.firstExecutionTime,
                'yyyy-MM-dd'
            ),
        };
        if (ruleId !== null) {
            // update rule

            const updateRuleBody = {
                description,
                condition: JSON.stringify(rulesData),
                scheduleData: updatedScheduleData,
                status: 'DRAFT',
            };
            dispatch(showLoading());
            updateRule(market, brand, ruleId, updateRuleBody)
                .then(() => {
                    onClose();
                    dispatch(
                        notify('Saved!', 'Your work has been saved in drafts.')
                    );
                })
                .catch((error) => {
                    dispatch(notifyError('Error!', 'Unable to save draft.'));
                })
                .finally(() => dispatch(hideLoading()));
        } else {
            // create rule

            const createRuleBody = {
                ruleName:
                    //  'CONSUMER',
                    description,
                description: description,
                condition: JSON.stringify(rulesData),
                scheduleData: updatedScheduleData,
                status: 'DRAFT',
            };
            dispatch(showLoading());
            createRule(market, brand, createRuleBody)
                .then(() => {
                    onClose();
                })
                .catch((error) => {
                    dispatch(notifyError('Error!', 'Unable to save draft.'));
                })
                .finally(() => dispatch(hideLoading()));
        }
    };
    const expireRule = () => {
        //const [ruleCondition, ruleAction] = generateMvelExpression(rulesData, actionsData, ATTRIBUTE_TYPE_BASED_ON_OPERATION);
        const updatedScheduleData = {
            ...scheduleData,
            scheduleTime: format(scheduleData?.scheduleTime, 'HH:mm'),
            firstExecutionTime: format(
                scheduleData?.firstExecutionTime,
                'yyyy-MM-dd'
            ),
        };
        const expireRuleBody = {
            description,
            condition: JSON.stringify(rulesData),
            scheduleData: updatedScheduleData,
            status: 'EXPIRED',
        };
        dispatch(showLoading());

        updateRule(market, brand, ruleId, expireRuleBody)
            .then(() => {
                onClose();
                dispatch(
                    notifySuccess(
                        'Rule Expired!',
                        'The Consumer rule has been successfully expired.'
                    )
                );
            })
            .catch((error) => {
                dispatch(notifyError('Error!', 'Unable to expire rule.'));
            })
            .finally(() => dispatch(hideLoading()));
    };
    const removeRule = () => {
        dispatch(showLoading());

        deleteRule(market, brand, ruleId)
            .then(() => {
                onClose();
                dispatch(
                    notify(
                        'Deleted Draft!',
                        'Draft has been successfully deleted.'
                    )
                );
            })
            .catch((error) => {
                dispatch(notifyError('Error!', 'Unable to delete draft.'));
            })
            .finally(() => dispatch(hideLoading()));
    };
    const publishRule = () => {
        // const [ruleCondition, ruleAction] = generateRule();
        //const [ruleCondition, ruleAction] = generateMvelExpression(rulesData, actionsData, ATTRIBUTE_TYPE_BASED_ON_OPERATION);
        const updatedScheduleData = {
            ...scheduleData,
            scheduleTime: format(scheduleData?.scheduleTime, 'HH:mm'),
            firstExecutionTime: format(
                scheduleData?.firstExecutionTime,
                'yyyy-MM-dd'
            ),
        };
        if (ruleId !== null) {
            const publishRuleBody = {
                description,
                condition: JSON.stringify(rulesData),
                scheduleData: updatedScheduleData,
                status: 'PUBLISHED',
            };
            dispatch(showLoading());
            updateRule(market, brand, ruleId, publishRuleBody)
                .then(() => {
                    onClose();
                    dispatch(
                        notifySuccess(
                            'Published!',
                            'The rule has been successfully published.'
                        )
                    );
                })
                .catch((error) => {
                    dispatch(notifyError('Error!', 'Unable to publish rule.'));
                })
                .finally(() => dispatch(hideLoading()));
        } else {
            const createRuleBody = {
                ruleName:
                    // 'CONSUMER',
                    description,
                description: description,
                condition: JSON.stringify(rulesData),
                scheduleData: updatedScheduleData,
                status: 'PUBLISHED',
            };
            dispatch(showLoading());

            createRule(market, brand, createRuleBody)
                .then(() => {
                    dispatch(
                        notifySuccess(
                            'Published!',
                            'The rule has been successfully published.'
                        )
                    );
                    onClose();
                })
                .catch((error) => {
                    dispatch(notifyError('Error!', 'Unable to publish rule.'));
                })
                .finally(() => dispatch(hideLoading()));
        }
    };
    const closeConfirmDialog = () => {
        setConfirmDialog({ ...confirmDialog, display: false });
    };
    useEffect(() => {
        if (ruleId !== null) {
            setLoading(true);
            dispatch(showLoading());

            getRule(market, brand, ruleId)
                .then((response) => {
                    const rule = response?.data;
                    setRule(rule);
                    setRulesData((prevrule) => {
                        return JSON.parse(rule?.condition);
                    });
                    // setScheduleData((prev) => {
                    //     const scheduleT = `2025-09-11T${rule?.schedule?.scheduleTime}.000Z`
                    //     const obj = { frequency: rule?.schedule?.frequency, dayName: rule?.schedule?.dayName, hourlyVal: rule?.schedule?.hourlyVal, loadType: rule?.schedule?.loadType, scheduleTime: scheduleT, firstExecutionTime: rule?.schedule?.firstExecutionTime || rule?.schedule?.executionTime };
                    //     return obj;

                    // });
                    setScheduleData((prev) => {
                        //console.log("rule?.schedule::::", rule?.schedule);
                        const scheduleT = `${format(
                            new Date(),
                            'yyyy-MM-dd'
                        )}T${rule?.schedule?.scheduleTime}.000`;
                        const firstExecTime =
                            rule?.schedule?.firstExecutionTime ||
                            rule?.schedule?.executionTime;
                        const firstExecTimeUTC = firstExecTime
                            ? new Date(firstExecTime)
                            : '';
                        const obj = {
                            frequency: rule?.schedule?.frequency,
                            dayName: rule?.schedule?.dayName,
                            hourlyVal: rule?.schedule?.hourlyVal,
                            loadType: rule?.schedule?.loadType,
                            scheduleTime: scheduleT,
                            firstExecutionTime: firstExecTimeUTC,
                            fileType: rule?.schedule?.fileType,
                            fileFields: rule?.schedule?.fileFields,
                            channelOfCommunication: rule?.schedule?.channelOfCommunication
                        };
                        //console.log("Obj::::", obj);
                        return obj;
                    });

                    setDescription(
                        rule?.description || generateRuleNamePrefix()
                    );
                })
                .catch((error) => {
                    dispatch(notifyError('Error!', 'Unable to fetch rules.'));
                })
                .finally(() => {
                    setLoading(false);
                    dispatch(hideLoading());
                });
        }
    }, []);

    const generateRuleNamePrefix = () => {
        return `${market?.toUpperCase()}-${brand?.toUpperCase()}`;
    };

    const isInvalidRules =()=>{
        const hasIncompleteRules = rulesData.some(group => 
            (group?.groups?.length>0 ?
                group?.groups.some((cGroup)=> 
                    !cGroup.entity ||
                    cGroup.rules.some(rule => 
                        !rule.entityAttribute || 
                        !rule.operation || 
                        (rule.operation !== 'is_null' && rule.operation !== 'is_not_null' && !rule.attributeValue)
                    )
                ) :
                !group.entity ||
                group.rules.some(rule => 
                    !rule.entityAttribute || 
                    !rule.operation || 
                    (rule.operation !== 'is_null' && rule.operation !== 'is_not_null' && !rule.attributeValue)
                )
            )
        );
        return hasIncompleteRules;
    }

    // useEffect(() => {
    //     const isValidData = validateRulesData();
    //     type === C.RULE_TYPE_EXPIRED
    //         ? setSaveEnabled(false)
    //         : setSaveEnabled(isValidData);
    // }, [actionsData, action, description]);
    return (
        <div
            className={`create-rule-container ${
                origin === C.RULE_EDITOR_MANAGE_PROGRAM &&
                'manage-rule-container'
            }`}
        >
            <div className="create-rule">
                <div className="create-rule-header">
                    <div className="create-rule-close">
                        <button
                            className="create-rule-close-btn"
                            onClick={onClose}
                        >
                            {/* <img src={closeIcon} alt="close" /> */}
                            <ArrowBackIcon />
                            {origin === C.RULE_EDITOR_CREATE_PROGRAM
                                ? ' Back to Rules'
                                : 'Back to Manage Rules'}
                        </button>
                    </div>
                    <div className="create-rule-title">
                        {origin === C.RULE_EDITOR_CREATE_PROGRAM ? (
                            <>
                                <h3>Create New Rule</h3>
                                <p>* All fields are mandatory</p>
                            </>
                        ) : type === C.RULE_TYPE_EXPIRED ? (
                            <h3>View Expired Rule</h3>
                        ) : type === C.RULE_TYPE_PUBLISHED ? (
                            <h3>View Published Rule</h3>
                        ) : (
                            <h3>Add Rule</h3>
                        )}
                    </div>
                </div>
                <fieldset className="dynamicRuleEditor">
                    <legend className="customLegend">Trigger Rule WHEN</legend>
                    {!loading && (
                        <DynamicRuleEditor
                            rulesData={rulesData}
                            setData={setRulesData}
                            isPublished={C.RULE_INPUT_DISABLED.includes(type)}
                            validationErrors={hasAttemptedSubmit && validationErrors.rules}
                        />
                    )}
                </fieldset>

                <fieldset className="dynamicRuleEditor">
                    <legend className="customLegend">Schedule</legend>
                    <Frequency
                        scheduleData={scheduleData}
                        setScheduleData={setScheduleData}
                        isPublished={C.RULE_INPUT_DISABLED.includes(type)}
                        validationErrors={hasAttemptedSubmit && validationErrors.schedule}
                        isDraft={isDraftMode}
                    />
                </fieldset>
                <fieldset className="dynamicRuleEditor">
                    <legend className="customLegend">File Configuration</legend>
                    <FileConfigForm 
                    scheduleData={scheduleData}
                    setScheduleData={setScheduleData}
                    isPublished={C.RULE_INPUT_DISABLED.includes(type)}/>
                </fieldset>
                <fieldset className="dynamicRuleEditor rule-description-container">
                    <div className="info-container">
                        <h4>Rule Name *:</h4>
                    </div>
                    <input
                        type="text"
                        id="ruleDescription"
                        name="description"
                        maxLength={65}
                        onChange={(e) => handleDescriptionChange(e)}
                        onKeyDown={(e) => {
                            const prefix = generateRuleNamePrefix();
                            if (
                                e.key === 'Backspace' &&
                                e.target.selectionStart <= prefix.length
                            ) {
                                e.preventDefault();
                            }
                        }}
                        value={description || generateRuleNamePrefix()}
                        placeholder={`${generateRuleNamePrefix()}Enter rule name`}
                        disabled={C.RULE_INPUT_DISABLED.includes(type)}
                        style={{
                             borderColor: validationErrors.description
                                ? 'red'
                                : description.length > 65
                                ? 'red'
                                : '',
                        }}
                    />
                    {description.length > 65 && (
                        <span style={{ color: 'red', fontSize: '12px' }}>
                            Rule name cannot exceed 65 characters
                        </span>
                    )}
                </fieldset>
                <div className="create-rule-cta-container">
                    {origin === C.RULE_EDITOR_CREATE_PROGRAM ? (
                        <>
                            <button
                                className={`save-rule ${
                                    saveEnabled ? 'active' : 'inactive'
                                }`}
                                onClick={() => saveEnabled && saveRule()}
                            >
                                Save Rule
                            </button>
                            {ruleId && (
                                <button
                                    className={`save-rule ${
                                        saveEnabled ? 'active' : 'inactive'
                                    }`}
                                    onClick={() => saveEnabled && removeRule()}
                                >
                                    Delete Rule
                                </button>
                            )}
                        </>
                    ) : type === C.LOYALTY_PROGRAM_STATUS_PUBLISHED ? (
                        <button
                            className="expire-rule"
                            onClick={() =>
                                setConfirmDialog({
                                    display: true,
                                    title: 'Confirm: Expire Rule!',
                                    message:
                                        'Are you sure you want to expire this Consumer rule?',
                                    note: 'Once you expire this rule will no longer be triggered or be re-activated.',
                                    onConfirm: expireRule,
                                    onClose: closeConfirmDialog,
                                    confirmText: 'Yes, Expire Rule',
                                    backText: 'No, Do Not Expire',
                                })
                            }
                        >
                            Expire Rule
                        </button>
                    ) : (
                        <>
                            <button
                                className={`publish-rule ${
                                    saveEnabled &&
                                    rule?.status !== C.RULE_TYPE_EXPIRED
                                        ? 'active'
                                        : 'inactive'
                                }`}
                                disabled={rule?.status === C.RULE_TYPE_EXPIRED}

                                onClick={() => {
                                    setIsDraftMode(false);
                                    setHasAttemptedSubmit(true);
                                    const prefix = generateRuleNamePrefix();
                                    const hasCustomText = description && description.length > prefix.length;

                                    const hasIncompleteRules = isInvalidRules();

                                    const errors = {
                                        description: !hasCustomText,
                                        rules: !rulesData.length || hasIncompleteRules,
                                        schedule: !isScheduleAdded,
                                    };

                                    setValidationErrors(errors);

                                    if (
                                        
                                        errors.description ||
                                        errors.rules ||
                                        errors.schedule
                                    ) {
                                        setConfirmDialog({
                                            display: true,
                                            title: 'Please Resolve All Error',
                                            note: 'Check if Description, Frequency, Rules are added Properly',
                                            // onConfirm: publishRule,
                                            onClose: closeConfirmDialog,
                                            // confirmText: 'Yes, Publish Rule',
                                            backText: 'Close',
                                        });
                                    } else if (saveEnabled) {
                                        setConfirmDialog({
                                            display: true,
                                            title: 'Confirm: Publish Rule!',
                                            note: 'Once you publish here you can not edit or update this rule. You can add new rules or expire the rule in manage rules.',
                                            onConfirm: publishRule,
                                            onClose: closeConfirmDialog,
                                            confirmText: 'Yes, Publish Rule',
                                            backText: 'No, Continue Editing',
                                        });
                                    }
                                }}
                                
                            >
                                Publish Rule
                            </button>
                            <button
                                disabled={rule?.status === C.RULE_TYPE_EXPIRED}
                                className={`save-rule ${
                                    saveEnabled &&
                                    rule?.status !== C.RULE_TYPE_EXPIRED
                                        ? 'active'
                                        : 'inactive'
                                }`}
                                // className='save-rule active'
                                // onClick={() =>
                                //     // generateMvelExpression(rulesData, actionsData, ATTRIBUTE_TYPE_BASED_ON_OPERATION)
                                //     saveEnabled &&
                                //     setConfirmDialog({
                                //         display: true,
                                //         title: 'Confirm: Save as Draft',
                                //         message:
                                //             'Are you sure you want to save as draft and navigate away from this screen?',
                                //         onConfirm: saveRule,
                                //         onClose: closeConfirmDialog,
                                //         confirmText: 'Yes, Save and Close',
                                //         backText: 'No, Continue Editing',
                                //     })
                                // }
                                onClick={() => {
                                    setIsDraftMode(true);
                                    setHasAttemptedSubmit(true);
                                    const prefix = generateRuleNamePrefix();
                                    const hasCustomText = description && description.length > prefix.length;
    
                                    const hasIncompleteRules = isInvalidRules();
                                    const errors = {
                                    description: !hasCustomText,
                                    rules: !rulesData.length || hasIncompleteRules,
                                    // schedule: !scheduleData?.loadType,               
                                    // schedule: false,  // Don't validate schedule for draft
                                    schedule: !isScheduleAdded
                                };
                                setValidationErrors(errors);
                                    
                                    // Don't validate schedule for draft
                                     if (errors.description || errors.rules || errors.schedule) {
                                        setConfirmDialog({
                                            display: true,
                                            title: 'Please Resolve All Error',
                                            note: 'Check if Description, Rules are added Properly',
                                            // onConfirm: publishRule,
                                            onClose: closeConfirmDialog,
                                            // confirmText: 'Yes, Publish Rule',
                                            backText: 'Close',
                                        });
                                    } else if (saveEnabled) {
                                        setConfirmDialog({
                                            display: true,
                                            title: 'Confirm: Save as Draft',
                                            message:
                                                'Are you sure you want to save as draft and navigate away from this screen?',
                                            onConfirm: saveRule,
                                            onClose: closeConfirmDialog,
                                            confirmText: 'Yes, Save and Close',
                                            backText: 'No, Continue Editing',
                                        });
                                    }
                                }}
                            >
                                Save as Draft
                            </button>
                            <button
                                className={`delete-rule ${
                                    ruleId &&
                                    saveEnabled &&
                                    String(type).toLowerCase() === 'draft'
                                        ? 'active'
                                        : 'inactive'
                                }`}
                                // className='delete-rule active'
                                onClick={() =>
                                    ruleId &&
                                    String(type).toLowerCase() === 'draft' &&
                                    // saveEnabled &&
                                    setConfirmDialog({
                                        display: true,
                                        title: 'Confirm: Delete Draft',
                                        message:
                                            'Are you sure you want to delete this draft and navigate away from this screen?',
                                        onConfirm: removeRule,
                                        onClose: closeConfirmDialog,
                                        confirmText: 'Yes, Delete Draft',
                                        backText: 'No, Continue Editing',
                                    })
                                }
                            >
                                Delete
                            </button>
                        </>
                    )}
                </div>
            </div>
            {confirmDialog.display && (
                <ConfirmDialog
                    title={confirmDialog.title}
                    message={confirmDialog.message}
                    note={confirmDialog.note}
                    onClose={confirmDialog.onClose}
                    onConfirm={confirmDialog.onConfirm}
                    confirmText={confirmDialog.confirmText}
                    backText={confirmDialog.backText}
                />
            )}
        </div>
    );
};

export default RuleEditor;
